import { useFormContext, useWatch } from "react-hook-form";
import { VestigingFormContext } from "../../../VestigingForm";
import { useFetchProductsQuery } from "../../../../../../../Domains/Products/api/productApi";
import React, { useMemo } from "react";
import _ from "lodash";
import Box from "@mui/material/Box";
import { DataGrid, GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { Checkbox, Typography } from "@mui/material";

export default function MissingApiIdsInExcel() {
  const { menukaartVestigingId } = useFormContext<VestigingFormContext>();

  const fields = useWatch({ name: "eds_connection__composed_id_mapping" });

  const { data } = useFetchProductsQuery(
    {
      gridFilterItems: { vestiging_id: { field: "vestiging_id", operator: "=", value: menukaartVestigingId } },
      pagination: { perPage: 100000, page: 0 },
      include: ["parent_option_groups"],
    },
    { skip: menukaartVestigingId == null || fields?.length === 0 }
  );
  const excelMap = useMemo(() => {
    return _.keyBy(fields, "article_id");
  }, [fields]);

  const missingArticles = useMemo(() => {
    return data?.data
      .filter(
        (productResponse) =>
          productResponse["parent_option_groups"] == null ||
          (Array.isArray(productResponse["parent_option_groups"]) &&
            productResponse["parent_option_groups"].length === 0)
      )
      .filter((productResponse) => excelMap[productResponse.apiId1] == null);
  }, [excelMap, data]);

  const columns = useMemo<GridColDef<(typeof rows)[number]>[]>(() => {
    return [
      { field: "id", headerName: "ID", width: 90 },
      {
        field: "naam",
        headerName: "Article name",
        width: 150,
        editable: false,
      },
      {
        field: "apiId1",
        headerName: "apiId1",
        width: 150,
        editable: false,
      },
      {
        field: "created_at",
        headerName: "Created at",
        width: 150,
        editable: false,
      },
      {
        field: "is_actief",
        headerName: "Is active",
        width: 150,
        editable: false,
        renderCell: (params: GridRenderCellParams<R, V, F>) => <Checkbox checked={params.value} disabled={true} />,
      },
      {
        field: "blocked",
        headerName: "Blocked",
        width: 150,
        editable: false,
        renderCell: (params: GridRenderCellParams<R, V, F>) => <Checkbox checked={params.value} disabled={true} />,
      },
    ];
  }, []);

  return (
    <Box sx={{ my: 4 }}>
      <Typography>Missing articles in excel</Typography>
      <DataGrid
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[5]}
        pagination
        rows={missingArticles}
      />
    </Box>
  );
}
